import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import NavBar from '../components/NavBar';
import Project from '../components/projects/Project';
import ViewProjects from '../components/projects/ViewProjects';
import { useParams } from 'react-router-dom';

const ProjectsView = () => {
    const projectId = useParams();
    return (
        <div>
            <Header />
            <NavBar />
            <Project projectIdToEdit={projectId}/>
            <ViewProjects limit={6} />
            <Footer />
        </div>
    )
}

export default ProjectsView
